export default __webpack_public_path__ + "static/media/zoomout_icon_bold.3b05a4ed.svg";